/*
*
* File JS per il template Archive Person
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroSimple from 'components/hero-simple/hero-simple';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import archiveFilters from 'components/archive-filters/archive-filters';
import cardPerson from 'components/card-person/card-person';
import bannerNotFound from 'components/banner-not-found/banner-not-found';

import contentBlocks from 'components/content-blocks/content-blocks';

import pagination from 'components/pagination/pagination';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-person.scss';

//--------------------------------------------------------------------//

// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

archiveFilters();
contentBlocks();

//--------------------------------------------------------------------//